/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import SummaryDetailsItem from "../../Common/SummaryDetailsItem/SummaryDetailsItem";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";
import summaryStyle from "./summaryStyle";

type PersonalDataProps = {
  basePath: string;
  product: AbstractCase;
};
const PersonalData = ({ basePath, product }: PersonalDataProps) => {
  const section = "personalData";
  const formPath = basePath + "/ihre-angaben";
  return (
    <>
      <Grid item xs={12} sx={summaryStyle.subHeadline}>
        <Typography variant={"h5"}>Persönliche Angaben</Typography>
      </Grid>
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.gender"} formUrl={formPath} anchorId={section} />
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.givenName"} formUrl={formPath} anchorId={section} />
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.familyName"} formUrl={formPath} anchorId={section} />
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.birthDate"} formUrl={formPath} anchorId={section} fieldType={"date"} />
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.residenceAddress.streetAddress"} formUrl={formPath} anchorId={section} />
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.residenceAddress.postalCode"} formUrl={formPath} anchorId={section} />
      <SummaryDetailsItem caseData={product} fieldPath={"petitioner.residenceAddress.addressLocality"} formUrl={formPath} anchorId={section} />
      <SummaryDetailsItem caseData={product} fieldPath={"customer.telephone"} formUrl={formPath} anchorId={section} />
      <SummaryDetailsItem caseData={product} fieldPath={"customer.contactTime"} formUrl={formPath} anchorId={section} />
      <SummaryDetailsItem caseData={product} fieldPath={"maritalStatus"} formUrl={formPath} anchorId={section} />

      {product.maritalStatus === "married" && (
        <>
          <SummaryDetailsItem caseData={product} fieldPath={"partnerIsWorking"} formUrl={formPath} anchorId={section} />
        </>
      )}
      <SummaryDetailsItem caseData={product} fieldPath={"numberChildren"} formUrl={formPath} anchorId={section} />
    </>
  );
};

export default PersonalData;
